{
  "characters": "teikn"
}
